<template>
  <div id="genericReport">
    <!-- TABELA DE BLOQUEADOS -->
    <div v-if="data && data.supplies" class="overflow-x-auto border border-slate-200 rounded-xl mb-12 shadow-sm">
      <table class="w-full text-left border-collapse min-w-[1000px]">
        <thead>
          <tr class="bg-slate-800 text-white">
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Data/Hora</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700">Item</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Litros</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Preço Lic.</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Preço Dia</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-right">Total R$</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-center">Cupom</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider border-r border-slate-700 text-center">Status</th>
            <th class="p-3 text-[10px] font-black uppercase tracking-wider">Motorista</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, index) in data.supplies" :key="index" class="border-b border-slate-100 hover:bg-slate-50 transition-colors">
            <td class="p-3 text-[10px] text-slate-500 border-r border-slate-100">{{ convertDateTime(value.datehour) }}</td>
            <td class="p-3 text-[10px] font-bold text-slate-700 border-r border-slate-100 uppercase">{{ value.item_description_desc }}</td>
            <td class="p-3 text-[10px] font-black text-slate-800 border-r border-slate-100 text-right">{{ realMaskII(value.supply_liters_stocked.toFixed(3)) }}</td>
            <td class="p-3 text-[10px] text-slate-600 border-r border-slate-100 text-right">{{ realMaskII(value.supply_price_day.toFixed(3)) }}</td>
            <td class="p-3 text-[10px] text-slate-600 border-r border-slate-100 text-right">{{ realMaskII(value.supply_bidding_price.toFixed(3)) }}</td>
            <td class="p-3 text-[10px] font-black text-slate-900 border-r border-slate-100 text-right font-mono">R$ {{ realMask(value.supply_value.toFixed(2)) }}</td>
            <td class="p-3 text-[9px] text-slate-400 border-r border-slate-100 text-center uppercase">{{ value.supply_coupon }}</td>
            <td class="p-3 text-[10px] border-r border-slate-100 text-center">
              <span class="px-2 py-1 rounded-full text-[9px] font-black uppercase" :class="value.supply_status === 'BLOQUEADO' ? 'bg-red-100 text-red-600' : 'bg-emerald-100 text-emerald-600'">
                {{ value.supply_status }}
              </span>
            </td>
            <td class="p-3 text-[10px] text-slate-600 uppercase">{{ value.driver_name }}</td>
          </tr>
        </tbody>
        <tfoot v-if="data.totals" class="bg-slate-50 border-t-2 border-slate-200">
           <tr class="font-black text-slate-800">
             <td colspan="2" class="p-4 text-[11px] uppercase tracking-widest text-slate-500">RESUMO DE BLOQUEADOS</td>
             <td class="p-4 text-right text-slate-900 text-xs">{{ realMask(data.totals.liters.toFixed(2)) }} L</td>
             <td class="p-4 text-right text-slate-600 text-xs">{{ realMask(data.totals.total.toFixed(2)) }}</td>
             <td class="p-4 text-right text-slate-600 text-xs">{{ realMask(data.totals.totalBidding.toFixed(2)) }}</td>
             <td class="p-4 text-right text-emerald-600 font-mono text-sm leading-none" colspan="4">
                <span class="block text-[8px] text-slate-400 mb-1">VALOR TOTAL ACUMULADO</span>
                R$ {{ realMask(data.totals.totalBidding.toFixed(2)) }}
             </td>
           </tr>
        </tfoot>
      </table>
    </div>

    <!-- TOTAIS CONSOLIDADOS (CARDS) -->
    <div v-if="data && data.totals" class="flex justify-end mt-12">
      <div class="bg-slate-800 rounded-2xl px-10 py-6 flex gap-12 items-center shadow-xl border border-slate-700">
        <div class="flex flex-col">
          <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">TOTAL LITROS</span>
          <span class="text-2xl font-black text-white text-right">
            {{ realMask(data.totals.liters.toFixed(2)) }} L
          </span>
        </div>
        <div class="w-px h-12 bg-slate-700"></div>
        <div class="flex flex-col">
          <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">VALOR TOTAL LICITADO</span>
          <span class="text-2xl font-black text-orange-400 text-right font-mono">
            R$ {{ realMask(data.totals.totalBidding.toFixed(2)) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>